import React from 'react'
import Box from '@mui/system/Box'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'
import CardMedia from '@mui/material/CardMedia'
import defaultImage from 'assets/images/default_avatar.png'
import { useLocation, useNavigate } from 'react-router-dom'

const ClaimPendingList = ({ reportData }) => {
  const {
    id,
    staff_name,
    staff_img,
    title,
    claim_report_type,
    amount_total,
    amount_payable,
    start_date,
    end_date,
  } = reportData
  const navigate = useNavigate()
  const backgroundLocation = useLocation()
  const displayAmount = amount_payable ?? amount_total

  return (
    <Box
      width={1}
      bgcolor="white.main"
      paddingX={{ xs: 2, lg: 3 }}
      paddingY={{ xs: 2, lg: 2 }}
      mb={2}
      boxSizing="border-box"
      sx={{
        boxShadow: 'none',
        borderRadius: '3.5px',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
      }}
      onClick={() =>
        navigate(`/app/approval-center/claim/request/${id}`, {
          state: {
            backgroundLocation,
            data: reportData,
          },
        })
      }
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ cursor: 'pointer' }}
      >
        <Box width={{ xs: 1, lg: 4 / 5 }} display="flex" alignItems="center" columnGap={2}>
          <Box display="flex" justifyContent="center" alignItems="center" width={90} height={90}>
            <Box position="relative" width={80} height={80}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  height: 52,
                  width: 52,
                  bgcolor: 'alternate.light',
                  objectFit: 'cover',
                  borderRadius: '50%',
                }}
              >
                <Icon
                  sx={{
                    fontSize: 26,
                    color: 'alternate.main',
                  }}
                >
                  article
                </Icon>
              </Box>
              <CardMedia
                component="img"
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  right: 0,
                  height: 52,
                  width: 52,
                  bgcolor: 'gray-background.main',
                  objectFit: 'cover',
                  borderRadius: '50%',
                  border: '3px solid',
                  borderColor: 'white.main',
                }}
                alt={staff_name}
                src={staff_img || defaultImage}
              />
            </Box>
          </Box>
          <Box
            width={{ xs: 1, lg: 'calc(100% - 100px)' }}
            height={85}
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
          >
            <Box>
              <Typography
                noWrap
                component="span"
                variant="body1"
                color="dark-gray.main"
                fontWeight="bold"
                textTransform="capitalize"
              >
                {title}
              </Typography>
              <Box display={'flex'} alignItems={'center'} columnGap={1.5} mt={0.5}>
                <Typography
                  component="span"
                  variant="body2"
                  color="light-gray-text.main"
                  textTransform="capitalize"
                >
                  {claim_report_type}
                </Typography>
                <Icon
                  sx={{
                    fontSize: 7,
                    color: 'light-gray-text.main',
                  }}
                >
                  circle_rounded
                </Icon>
                <Typography
                  width={1}
                  noWrap
                  component="span"
                  variant="body2"
                  color="light-gray-text.main"
                  textTransform="capitalize"
                >
                  {start_date} - {end_date}
                </Typography>
              </Box>
            </Box>
            <Typography
              display={{ xs: 'none', lg: 'block' }}
              width={6 / 7}
              minWidth={400}
              variant="body2"
              color="light-gray-text.main"
              textTransform="capitalize"
            >
              {`Requester : ${staff_name}`}
            </Typography>
            <Typography
              display={{ xs: 'flex', lg: 'none' }}
              noWrap
              component="span"
              variant="h4"
              fontWeight="bold"
              color="alternate.main"
              sx={{
                textDecoration: 'underline',
              }}
            >
              {`RM ${parseFloat(displayAmount).toFixed(2)}`}
            </Typography>
          </Box>
        </Box>
        <Box
          width={1 / 5}
          display={{ xs: 'none', lg: 'flex' }}
          justifyContent="flex-end"
          alignCenter="center"
          columnGap={1}
        >
          <Typography
            noWrap
            component="span"
            variant="h4"
            fontWeight="bold"
            color="alternate.main"
            sx={{
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          >
            {`RM ${parseFloat(displayAmount).toFixed(2)}`}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default ClaimPendingList
